import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { EnvService } from 'src/app/services/env.service';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  public socket: Socket;
  public socketApiModals: Socket;

  constructor(private env: EnvService) {
    this.socket = io(this.env.URL_SOCKET_V1);
  }
}
